import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

export const videoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    getVideos: (state) => {
      state.loading = true;
    },
    successVideo: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    failedVideo: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getVideos,
  successVideo,
  failedVideo,
} = videoSlice.actions;

export default videoSlice.reducer;
